namespace GeniuzPOS.ReportMasterData {
    export interface Report_1321Form {
    }

    export class Report_1321Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1321';
    }
}
